import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { Media } from '../../../../../theme/Media.js';
import { Button } from '../../../../Controls/Button/index.js';
import Icons from '../../../../Elements/Icons/index.js';
import { Select } from '../../../../Form/Select/index.js';
import { PageInfo } from '../PageInfo/index.js';
import { TableInfo } from '../TableInfo/index.js';
import { paginationPresetDefault, paginationPresetReduced } from './constants.js';
import { PageInfoWrapper, Wrapper } from './styled.js';
export const TablePagination = memo(function TablePagination({ className, pagination, isLoading, dataTestId }) {
    const { perPage, from, to, total, setPerPage, nextPage, prevPage, hasNext, hasPrev } = pagination;
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const selectedPerPage = useMemo(() => ({ label: String(perPage), value: perPage }), [perPage]);
    const isReducedPaginationPreset = useMemo(() => !!paginationPresetReduced.find((option) => option.value === perPage), [perPage]);
    const handleSetPerPage = useCallbackRef((option) => {
        if (option) {
            setPerPage(option.value);
        }
    });
    if (!isLoading && total <= perPage) {
        return _jsx(TableInfo, { total: total, isLoading: isLoading });
    }
    return (_jsxs(Wrapper, { className: className, "data-testid": dataTestId, children: [!isMobile && (_jsx("div", { "data-testid": 'per-page-dropdown', children: _jsx(Select, { options: isReducedPaginationPreset ? paginationPresetReduced : paginationPresetDefault, value: selectedPerPage, onChange: handleSetPerPage, menuPlacement: 'auto', "data-testid": 'select-op' }) })), _jsx(PageInfoWrapper, { children: _jsx(PageInfo, { dataTestId: 'from-to-total-pagination', from: from, to: to, total: total, isLoading: isLoading }) }), _jsx(Button, { secondary: true, iconOnly: true, onClick: prevPage, disabled: !hasPrev, "data-testid": 'backward-button', children: _jsx(Icons.Arrow, { align: 'left' }) }), _jsx(Button, { secondary: true, iconOnly: true, onClick: nextPage, disabled: !hasNext, "data-testid": 'forward-button', children: _jsx(Icons.Arrow, { align: 'right' }) })] }));
});
export { usePagination } from './usePagination.js';
